import moment from 'moment'
/**
 * Created by mly on 2017/12/19.
 */
export function createExpenseTeam() {
  return {
    expense_id: 0,
    team_id: 0,
    price: 0.00,
    desc: ''
  }
}
export function createExpense() {
  return {
    name: '',
  expense_type_id: 0,
  contract_uid: '',
  invoice_uid: '',
  invoice_type: -1,
  price: 0.00,
  tax: 0.00,
  tax_rate: '0.0',
  is_estimate_tax: true,
  invoice_price: 0.00,
  desc: '',
  is_repair: false,
  expense_teams: [createExpenseTeam()],
  // 业务单据分析字段
  expense_nature_id: 0,
  customer_function_id: 0,
  customer_type: -1,
  item_type_id: 0,
  fund_usage_id: 0,
  is_insider_trading: false,
  account_title_id: 0,
  analysis_title_id: 0,
  placing_ads_records_sum: 0,
  }
}
import Util from './util';
const expense_util = {
  currencies: [
    {
      value: 'CNY',
      label: '人民币',
      symbol: '￥'
    },
    {
      value: 'USD',
      label: '美元',
      symbol: '$'
    },
    {
      value: 'EUR',
      label: '欧元',
      symbol: '€'
    },
    {
      value: 'GBP',
      label: '英镑',
      symbol: '£'
    },
    {
      value: 'HKD',
      label: '港币',
      symbol: '$'
    }
  ],
  getModalName(payment_type) {
    let text;
    switch (payment_type) {
      case 0:
        text = 'ExpenseGroupBX';
        break;
      case 1:
        text = 'ExpenseGroupFK';
        break;
      case 2:
        text = 'ExpenseGroupYZ';
        break;
      case 3:
        text = 'ExpenseGroupCZ';
        break;
      case 4:
        text = 'ExpenseGroupFK';
        break;
      case 5:
        text = 'ExpenseGroupJT';
        break;
      case 6:
        text = 'ExpenseGroupJR';
        break;
      case 7:
        text = 'ExpenseGroupCX';
        break;
      case 8:
        text = 'ExpenseGroupFP';
        break;
      case 9:
        text = 'ExpenseGroupZD';
        break;
      default:
        text = '未定义单据类型';
        break;
    }
    return text;
  },
  getPaymentType(payment_type) {
    let text;
    switch (payment_type) {
      case 0:
        text = '报销';
        break;
      case 1:
        text = '付款';
        break;
      case 2:
        text = '预支';
        break;
      case 3:
        text = '充值';
        break;
      case 4:
        text = '付款';
        break;
      case 5:
        text = '计提';
        break;
      case 6:
        text = '计提修正';
        break;
      case 7:
        text = '充值冲销';
        break;
      case 8:
        text = '发票提交';
        break;
      case 9:
        text = '账单提交';
        break;
      default:
        text = '未定义单据类型';
        break;
    }
    return text;
  },
  getPayeeType(expense_group) {
    let text;
    switch (expense_group.payment_type) {
      case 0:
        text = 'staff';
        break;
      case 1:
        text = expense_group.is_outsource ? 'person' : 'all';
        break;
      case 2:
        text = 'staff';
        break;
      case 3:
        text = 'all';
        break;
      case 4:
        text = 'all';
        break;
      case 5:
        text = 'all';
        break;
      case 6:
        text = 'all';
        break;
      case 7:
        text = 'all';
        break;
      default:
        text = '';
        break;
    }
    return text;
  }
};
// gen currencies hash
expense_util.currencies_hash = {};
expense_util.currencies.forEach((currency) => {
  expense_util.currencies_hash[currency.value] = currency;
});
expense_util.currencies_label_hash = expense_util.currencies.reduce((t, i) => {
  t[i.label] = i
  return t}, {})
expense_util.new_expense_team = {
  expense_id: 0,
  team_id: 0,
  price: 0.00,
  desc: ''
};
expense_util.new_expense = {
  name: '',
  expense_type_id: 0,
  contract_uid: '',
  invoice_uid: '',
  invoice_type: -1,
  price: 0.00,
  tax: 0.00,
  tax_rate: '0.0',
  is_estimate_tax: true,
  invoice_price: 0.00,
  desc: '',
  is_repair: false,
  expense_teams: [Util.clone(expense_util.new_expense_team)],
  // 业务单据分析字段
  expense_nature_id: 0,
  customer_function_id: 0,
  customer_type: -1,
  item_type_id: 0,
  fund_usage_id: 0,
  is_insider_trading: false,
  account_title_id: 0,
  analysis_title_id: 0,
};
expense_util.new_expense_group = {
  kind: 'common',
  name: '',
  payment_type: 0,
  advance_id: 0,
  advance: {},
  accrual_id: 0,
  accrual: {},
  contract_id: 0,
  contract: {},
  cyn_total_price: 0,
  outsource_contract_id: 0,
  outsource_contract: {},
  has_stocks: false,
  is_simple: false,
  is_outsource: false,
  can_cross_company: false,
  uid: '',
  apply_user: '',
  apply_user_id: 0,
  fill_user: '',
  fill_user_id: 0,
  company_id: '',
  team_id: '',
  verified_at: '',
  paid_at: '',
  expense_payment_bank_id: 0,
  payment_bank_name: '',
  payment_bank_account: '',
  payment_bank_number: '',
  payee_bank: '',
  payee_account_name: '',
  payee_account: '',
  payee_user: '',
  payee_user_id: 0,
  payee_company: '',
  payee_company_id: 0,
  payee_company_account_id: 0,
  currency: '',
  total_price: 0.00,
  fin_bill_kinds: '',
  return_expense_group_id: 0,
  desc: '',
  expenses: [Util.clone(expense_util.new_expense)],
  banks: [],
  bfiles: [],
  expect_reverse_at: moment().add(1, 'months').format("YYYY-MM-DD")
}
const expense_group_without_expenses = Util.clone(expense_util.new_expense_group);
expense_group_without_expenses.expenses = null;
expense_util.new_expense_group_advance = expense_group_without_expenses;
expense_util.new_expense_group_recharge = expense_group_without_expenses;
expense_util.isForeignCurrency = (currency_value) => {
  return currency_value !== 'CNY';
};
expense_util.getCurrencyName = (currency_value) => {
  const currency = expense_util.currencies_hash[currency_value];
  return `${currency.symbol}-${currency.label}`;
};
expense_util.getCurrencyLabel = (currency_value) => {
  const currency = expense_util.currencies_hash[currency_value];
  return currency.label;
};
expense_util.getCurrencySymbol = (currency_value) => {
  const currency = expense_util.currencies_hash[currency_value];
  return currency.symbol;
};
expense_util.setPlaceArr = () => {
  return {
    tfjc_type: 0, // 0:投放记录；1:加成服务
    placing_ads_records: [], // 投放记录
    placing_ads_vas_records:[], // 加成服务
  }
}
export default expense_util;
